var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.customerId && _vm.contractId)?_c('digital-signature',{attrs:{"customer-id":_vm.customerId,"contract-id":_vm.contractId,"parent-component":"validationRequestForm"}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fdbcc11","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Demands/DigitalSignatureTab.vue
// module id = 1898
// module chunks = 0